export default __webpack_public_path__ + "static/media/logo.47dd6855.png";